import { query, mutation, chimeraQuery } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    board_subsections: [],
    board_section: null,
  },
  mutations: {
    SET_CURRENT_BOARD_SUBSECTION(state: any, board_subsection: any) {
      state.board_subsection = board_subsection;
    },
    SET_BOARD_SUBSECTIONS(state: any, board_subsections: any) {
      state.board_subsections = board_subsections;
    },
    SET_EMPTY_BOARD_SUBSECTION(state: any) {
      state.board_subsection = {
        id: null,
        title: null,
        description: null,
        descomplicaTopicSlug: null,
        boardSectionByBoardSectionId: {
          id: null,
          title: null,
        },
      };
    },
  },
  actions: {
    async PULL_BOARD_SUBSECTION({ commit }: any, boardSubsectionId: number) {
      let response = await query(
        `query getBoardSubsectionByIdDexAdmin($boardSubsectionId: Int!) {
            boardSubsectionById(id: $boardSubsectionId) {
              id
              title
              description
              descomplicaTopicSlug
              materialsByBoardSubsectionsId {
                nodes {
                  id
                  listByListId {
                    id
                    name
                  }
                  examGroupByExamGroupId {
                    id
                    name
                  }
                }
              }
              boardSectionByBoardSectionId {
                id
                title
                descomplicaSubjectSlug
                boardByBoardId {
                  id
                  descomplicaDisciplineSlug
                }
              }
            }
          }`,
        {
          boardSubsectionId: boardSubsectionId,
        },
      );
      let boardSubsection = response.data.boardSubsectionById;
      if (boardSubsection) {
        commit('SET_CURRENT_BOARD_SUBSECTION', boardSubsection);
      }
    },
    async PULL_BOARD_SUBSECTIONS({ commit }: any) {
      let response = await query(`query getAllBoardSubsectionsDexAdmin{
        allBoardSubsections(first: 200, orderBy: ID_DESC) {
          nodes {
            id
            title
            description
            descomplicaTopicSlug
            boardSectionByBoardSectionId {
              id
              title
            }
          }
        }
      }`);
      let boardSubsectionNodes = response.data.allBoardSubsections;
      if (boardSubsectionNodes) {
        commit('SET_BOARD_SUBSECTIONS', boardSubsectionNodes.nodes);
      }
    },
    async PUSH_BOARD_SUBSECTION({ commit }: any, boardSubsection: any) {
      if (boardSubsection.id) {
        let response = await mutation(
          `mutation dexAdminUpdateBoardSubsectionById($id: Int!, $title: String!, $description: String, $descomplicaTopicSlug: String, $boardSectionId: Int!) {
          updateBoardSubsectionById(
            input: {
              id: $id
              boardSubsectionPatch: {
                title: $title
                description: $description
                descomplicaTopicSlug: $descomplicaTopicSlug
                boardSectionId: $boardSectionId
              }
            }) {
            boardSubsection {
              id
              title
              description
              descomplicaTopicSlug
              boardSectionByBoardSectionId {
                id
                title
                descomplicaSubjectSlug
                boardByBoardId {
                  id
                  descomplicaDisciplineSlug
                }
              }
            }
          }
        }`,
          {
            id: boardSubsection.id,
            title: boardSubsection.title,
            description: boardSubsection.description,
            descomplicaTopicSlug: boardSubsection.descomplicaTopicSlug,
            boardSectionId: boardSubsection.boardSectionByBoardSectionId.id,
          },
        );
        commit(
          'SET_CURRENT_BOARD_SUBSECTION',
          response.data.updateBoardSubsectionById.boardSubsection,
        );
      } else {
        // TODO: find out why RLS complains about insert
        let response = await mutation(
          `mutation dexAdminCreateBoardSubsection($title: String!, $description: String, $descomplicaTopicSlug: String, $boardSectionId: Int!) {
          createBoardSubsection(
            input: {
              boardSubsection: {
                title: $title
                description: $description
                descomplicaTopicSlug: $descomplicaTopicSlug
                boardSectionId: $boardSectionId
              }
            }) {
            boardSubsection {
              id
              title
              description
              descomplicaTopicSlug
              boardSectionByBoardSectionId {
                id
                title
                descomplicaSubjectSlug
                boardByBoardId {
                  id
                  descomplicaDisciplineSlug
                }
              }
            }
          }
        }`,
          {
            title: boardSubsection.title,
            description: boardSubsection.description,
            descomplicaTopicSlug: boardSubsection.descomplicaTopicSlug,
            boardSectionId: boardSubsection.boardSectionByBoardSectionId.id,
          },
        );
        commit(
          'SET_CURRENT_BOARD_SUBSECTION',
          response.data.createBoardSubsection.boardSubsection,
        );
      }
    },
  },
};
